import createIcon from '../../createIcon';

/**
 * @component @name NestCamWiredStand
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuODMgMS4wMDg0MkwxMS43MiAxLjQyODQyQzguNDcgMS43NDg0MiA2IDQuNDc4NDIgNiA3Ljc0ODQyQzYgMTEuMDE4NCA4LjQ3IDEzLjc0ODQgMTEuNzIgMTQuMDc4NEwxMy42MiAxNC4yNjg0TDEzLjA2IDE1LjExODRDMTIuNzEgMTUuMDM4NCAxMi4zNiAxNC45OTg0IDEyIDE0Ljk5ODRDOS4yNCAxNC45OTg0IDcgMTcuMjM4NCA3IDE5Ljk5ODRWMjEuOTk4NEM3IDIyLjU0ODQgNy40NSAyMi45OTg0IDggMjIuOTk4NEgxNkMxNi41NSAyMi45OTg0IDE3IDIyLjU0ODQgMTcgMjEuOTk4NFYxOS45OTg0QzE3IDE4LjMyODQgMTYuMTcgMTYuODQ4NCAxNC45MSAxNS45Mzg0TDE1Ljg4IDE0LjQ4ODRDMTcuMDIgMTQuNTU4NCAxOCAxMy42NTg0IDE4IDEyLjQ5ODRWMi45OTg0MkMxOCAxLjgyODQyIDE3IDAuOTA4NDIzIDE1LjgzIDEuMDA4NDJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NestCamWiredStand = createIcon('NestCamWiredStand', [
  [
    'path',
    {
      d: 'M15.83 1.00842L11.72 1.42842C8.47 1.74842 6 4.47842 6 7.74842C6 11.0184 8.47 13.7484 11.72 14.0784L13.62 14.2684L13.06 15.1184C12.71 15.0384 12.36 14.9984 12 14.9984C9.24 14.9984 7 17.2384 7 19.9984V21.9984C7 22.5484 7.45 22.9984 8 22.9984H16C16.55 22.9984 17 22.5484 17 21.9984V19.9984C17 18.3284 16.17 16.8484 14.91 15.9384L15.88 14.4884C17.02 14.5584 18 13.6584 18 12.4984V2.99842C18 1.82842 17 0.908423 15.83 1.00842Z',
      key: '1c31re',
    },
  ],
]);

export default NestCamWiredStand;
